import * as React from 'react';
import {
  ExperimentalConfigureRelatedItems,
  InstantSearch,
  Configure,
} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

import { RelatedHits, RelatedHit } from './search';
import { searchClient, index } from '../utilities/search-client';

function RelatedProducts({ product: { title: productTitle } }) {
  const [hit, setHit] = React.useState(null);

  React.useEffect(() => {
    index.search(productTitle).then(({ hits }) => {
      setHit(hits[0]);
    });
  }, [productTitle]);

  if (!hit) return null;
  return (
    <InstantSearch indexName="shopify_products" searchClient={searchClient}>
      <Configure
        filters={`inventory_available:true AND NOT title:"${hit.title}"`}
        hitsPerPage={4}
      />
      <article className="mt-24">
        <h2 className="text-center h2">You May Also Like</h2>
        <ExperimentalConfigureRelatedItems
          hit={hit}
          matchingPatterns={{
            vendor: { score: 1 },
            tags: { score: 2 },
            product_type: { score: 2 },
          }}
        />
        <RelatedHits HitComponent={RelatedHit} />
      </article>
    </InstantSearch>
  );
}

RelatedProducts.propTypes = {
  product: PropTypes.object,
};

export { RelatedProducts };
